import { useEffect, useState } from 'react';
import { createBox3D } from 'box3d-web';

interface SmokeState {
  stepped: number;
  bodyCount: number;
  y: number;
}

declare global {
  interface Window {
    __box3dReady?: SmokeState;
  }
}

// Module-level guard: React StrictMode double-invokes effects in dev; one WASM
// boot is enough for the smoke probe.
let bootStarted = false;

async function bootSmokeWorld(): Promise<SmokeState> {
  const box3d = await createBox3D();
  const world = box3d.createWorld({ gravity: [0, -9.81, 0] });

  const ground = world.createBody({ type: 'static', position: [0, -1, 0] });
  world.addBox(ground, [10, 0.5, 10], { friction: 0.9 });

  const box = world.createBody({ type: 'dynamic', position: [0, 3, 0] });
  world.addBox(box, [0.5, 0.5, 0.5], { density: 1, friction: 0.5 });

  for (let i = 0; i < 10; i += 1) {
    world.step(1 / 60, 4);
  }

  const ids = new Int32Array([box as unknown as number]);
  const out = new Float32Array(7);
  world.readTransforms(ids, out);

  return { stepped: 10, bodyCount: world.bodyCount(), y: out[1] };
}

export default function Smoke() {
  const [state, setState] = useState<SmokeState | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (bootStarted) return;
    bootStarted = true;
    bootSmokeWorld()
      .then((next) => {
        window.__box3dReady = next;
        setState(next);
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : String(err));
      });
  }, []);

  return (
    <main style={{ padding: '2rem' }}>
      <h1>Destruction Lab — Box3D smoke</h1>
      <div data-testid="smoke-status">
        {error
          ? `error: ${error}`
          : state
            ? `stepped: ${state.stepped}, bodies: ${state.bodyCount}, y: ${state.y.toFixed(3)}`
            : 'booting box3d…'}
      </div>
    </main>
  );
}
